import React from "react";
import { useLocation, Link } from "react-router-dom"; import { useEffect } from "react";
import "./Header.css";

const Header = () => {
  const location = useLocation();
  useEffect(() => {
    const section = document.getElementById("education");

    const observer = new IntersectionObserver(
      ([entry]) => {
        const bar = document.querySelector(".ecosystem-top");

        if (entry.isIntersecting) {
          bar.classList.add("show-eco");
        } else {
          bar.classList.remove("show-eco");
        }
      },
      { threshold: 0.6 }
    );

    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);
  return (
    <>
      <nav className={`navbar navbar-expand-lg custom-navbar `}>        <div className="container-fluid">

        {/* LOGO */}
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img
            src={process.env.PUBLIC_URL + "/images/logo.png"}
            alt="TIG"
            className="logo"
          />
          <span className="brand">Techno India Group</span>
        </a>

        {/* TOGGLER */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div className="collapse navbar-collapse justify-content-end" id="mainNavbar">
          <ul className="navbar-nav nav-menu">

            <li className="nav-item">
              <a className="nav-link" href="/">Home</a>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/about">About</Link>
            </li>

            {/* DROPDOWN */}


            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                Initiatives
              </a>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/education">Education</Link></li>
                <li><Link className="dropdown-item" to="/sports">Sports</Link></li>
                <li><Link className="dropdown-item" to="/hospitality">Hospitality</Link></li>
                <li><Link className="dropdown-item" to="/media">Media</Link></li>
                <li><Link className="dropdown-item" to="/healthcare">Healthcare</Link></li>
              </ul>
            </li>

            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                Highlights
              </a>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/gallery">Gallery</Link></li>
                <li><Link className="dropdown-item" to="/event">Events</Link></li>
                <li><Link className="dropdown-item" to="/newsclippings">News Clippings</Link></li>
              </ul>
            </li>
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown">
                Techno Echo
              </a>
              <ul className="dropdown-menu">
                <li><a className="dropdown-item" target="_blank" href="/pdf/techno-echo/TECHNO-ECHO_FEB_2025_VOL_2_ISSUE_1.pdf">Vol.2</a></li>
                <li><a className="dropdown-item" target="_blank" href="/pdf/techno-echo/TECHNO-ECHO-july-2024_Vol.1_Issue1.pdf">Vol.1</a></li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/Contact">Contact</Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" target="_blank" href="https://careers.technoindiagroup.in/">Career</a>
            </li>

          </ul>
        </div>

      </div>
      </nav>

    </>
  );
};

export default Header;